const config = {
  kindOfInput: "FS",
};

export { config as eurotextConfig };
